module.exports = __webpack_public_path__ + "img/2.5d_1.c79eba5a.jpg";